<template>
  <footer>
    <div class="text-center bg-black text-white py-10">
      <p>Copyright © Camila's Art, All Right Reserved</p>
    </div>
  </footer>
</template>

<script setup>

</script>

<style>

</style>